// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"382":"fbf2380a87888357","524":"2359ca3d66877c48","606":"95d1a4c61b93c6f1"}[chunkId] + ".js";
};